import { lazy } from "react";

export const UpdateServiceAsync = lazy(() => import("./UpdateService"));
